import React, { useEffect, useRef, useState } from 'react'
import Footer from '../common/Footer'
import Header from '../common/Header'
import { Link } from 'react-router-dom'
import promocodeshero from "../../images/promo-codes-hero-img-1.2.webp";
import btnleftshap from "../../images/btn-left-shap.webp";
import btnrightshap from "../../images/btn-right-shap.webp";
 const Blogdetals = () => {

   let base_image_url = process.env.REACT_APP_IMAGE_URL;
    const [langcode, setLangcode] = useState(
      JSON.parse(localStorage.getItem("langcode")) || {
        Code: "en",
        Name: "English",
      }
    );
  
    function useMediaQuery(query) {
      const [matches, setMatches] = useState(false);
      useEffect(() => {
        const mql = window.matchMedia(query);
        const handler = e => setMatches(e.matches);
        mql.addEventListener('change', handler);
        setMatches(mql.matches);
        return () => mql.removeEventListener('change', handler);
      }, [query]);
      return matches;
    }
  
    const isDesktop = useMediaQuery('(min-width: 1402px)');
    const wrapperRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [aboutpagedata, setAboutpagedata] = useState();
    useEffect(() => {
      if (!isDesktop) return;
      const handleScroll = () => {
        setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
      };
  
      const handleResize = () => {
        if (wrapperRef.current) {
          document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
        }
      };
  
      // Initial setup
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
        document.body.style.overflow = "auto";
  
        wrapperRef.current.style.transition = "transform 0.3s ease-out";
        wrapperRef.current.style.position = "fixed";
        wrapperRef.current.style.top = "0";
        wrapperRef.current.style.left = "0";
        wrapperRef.current.style.width = "100%";
        wrapperRef.current.style.padding = "0";
        wrapperRef.current.style.zIndex = "2";
        wrapperRef.current.style.display = "block";
        wrapperRef.current.style.backfaceVisibility = "hidden";
      }
  
      // Add scroll and resize listeners
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);
  
      // Cleanup on component unmount
      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
      };
    }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  
    // Apply scroll effect to the wrapper
    useEffect(() => {
      if (wrapperRef.current) {
        wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
      }
    }, [scrollTop]);
    useEffect(() => {
      document.body.style.backgroundColor = "#000000";
      return () => {
        document.body.style = {};
      };
    }, []);
    useEffect(() => {
      const handleStorageChange = () => {
        const newLangcode = localStorage.getItem("langcode");
        setLangcode(JSON.parse(newLangcode)); // Update the state when langcode changes
      };
  
      window.addEventListener("storage", handleStorageChange);
  
      // Cleanup listener on component unmount
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }, []);

  return (
    <div className="home">
      <div className="main-page" ref={wrapperRef}>
        <Header />
          <section className="blogMainSec">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="post-breadcrumbs-list">
                    <Link to="">Equlix blog</Link> / 
                    <Link to="">Knowledge base</Link> / 
                    <Link to="">Trading</Link> /
                    <span>Countdown to Treasures ’26 Is On</span>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-12">
                  <div className="blog-left-sidebar">
                    <h4 className="sidebar_title">News & Events</h4>
                    <ul className="eq-cat-group-links">
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Signals <span>2659</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          News <span>344</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Data <span>84</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Humor <span>4</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Events <span>2</span>
                        </Link>
                      </li>
                    </ul>
  
                    <h4 className="sidebar_title">Knowledge base</h4>
                    <ul className="eq-cat-group-links">
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Markets <span>1025</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Trading <span>820</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Calculators <span>4</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Regulation and safety <span>80</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Learning <span>620</span>
                        </Link>
                      </li>
                    </ul>
  
                    <h4 className="sidebar_title">Interesting</h4>
                    <ul className="eq-cat-group-links">
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Reviews <span>248</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Trading platforms <span>300</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Bonificaciones y promociones <span>10</span>
                        </Link>
                      </li>
                      <li className="eq-cat-group-item">
                        <Link to="">
                          Estrategias de Trading <span>150</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <div className="blogCenter_Col">
                    <h1 className="blogdetal-title">Countdown to Treasures ’26 Is On</h1>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="blogItem-one">
                      <div className="blog-dt-link">
                        <img src={promocodeshero} alt="" />
                      </div>
                      <div class="eq-banner__link-decor">
                        <div className="btn_onImg">
                          <img className="left0" src={btnleftshap} alt="" />
                          <span className="blogview">
                            <label className="m-0"><i class="fa-regular fa-eye"></i> 102</label> 
                            <label className="m-0"><i class="fa-regular fa-message"></i> 0</label>
                          </span>
                          <img className="right0" src={btnrightshap} alt="" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="blogdetal-content">
                      <p>The biggest event of the year is about to begin. Coins are clinking, fortune is winking, and treasures keep coming. The start is December 8 — stay tuned</p>
                      <h2>Start the game one step ahead</h2>
                      <p>Everyone who’s made a deposit in 2025 can join. Сlaim your early treat to have your balance ready for the event. Activate promo code TREASURES26 to receive a 100% boost on a deposit starting from 100 USD.</p>
                      <h2>Dates</h2>
                      <p>Start: 8 December 2025, 00:00 GMT +2
                      <br />End: 28 December 2025, 23:59 GMT +2</p>
                      <h2>Treasures of ’26 for Everyone</h2>
                      <p>iPhone 17 Pro Max, PlayStation 5, MacBook Air, Xbox Series X, and hundreds of other treasures await. Is fortune on your side?</p>
                      <h2>Trade for Treasures Game</h2>
                      <p>12 heroes are ready to give you coins. Finish their trading quests and turn the coins you received into real funds.</p>
                      <p>Catch the moment early. Everyone who have successfully deposited in 2025 can participate. Have your balance ready for the event.</p>
                      <p>Every registered client is eligible to participate in the promotion “Treasures of ’26: Countdown”. Promo code is valid until December 8, 2025. Reward funds are credited instantly and can be used in trading to strengthen your trading potential.</p>
                      <p>The biggest event of the year is about to begin. Coins are clinking, fortune is winking, and treasures keep coming. The start is December 8 — stay tuned</p>
                      <h2>Start the game one step ahead</h2>
                      <p>Everyone who’s made a deposit in 2025 can join. Сlaim your early treat to have your balance ready for the event. Activate promo code TREASURES26 to receive a 100% boost on a deposit starting from 100 USD.</p>
                      <h2>Dates</h2>
                      <p>Start: 8 December 2025, 00:00 GMT +2
                      <br />End: 28 December 2025, 23:59 GMT +2</p>
                      <h2>Treasures of ’26 for Everyone</h2>
                      <p>iPhone 17 Pro Max, PlayStation 5, MacBook Air, Xbox Series X, and hundreds of other treasures await. Is fortune on your side?</p>
                      <h2>Trade for Treasures Game</h2>
                      <p>12 heroes are ready to give you coins. Finish their trading quests and turn the coins you received into real funds.</p>
                      <p>Catch the moment early. Everyone who have successfully deposited in 2025 can participate. Have your balance ready for the event.</p>
                      <p>Every registered client is eligible to participate in the promotion “Treasures of ’26: Countdown”. Promo code is valid until December 8, 2025. Reward funds are credited instantly and can be used in trading to strengthen your trading potential.</p>
                      
                    </div>


                    <div className="post-social-share">
                      <div className="post-default-actions">
                        <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                        <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                      </div>
                      <div className="post-social-share__list">
                        <span className="text-white">Share this article:</span>
                        <Link to=""><i class="fa-brands fa-x-twitter"></i></Link>
                        <Link to=""><i class="fa-brands fa-facebook-f"></i></Link>
                        <Link to=""><i class="fa-brands fa-linkedin-in"></i></Link>
                        <Link to=""><i class="fa-brands fa-telegram"></i></Link>
                        <Link to=""><i class="fa-solid fa-envelope"></i></Link>
                        <Link to=""><i class="fa-solid fa-link"></i></Link>
                      </div>
                    </div>

                    
                    <div className="blogTopics-card">
                      <h4 className="blog_title mb-3"><i class="fa-regular fa-user"></i> Your comment</h4>
                      <form className="pb-3">
                        <div className="commentsBox-filds">
                          <textarea id="commentsBox" name="comments" rows="1" placeholder="Write your comment here..." className="form-control mb-3"></textarea>
                          <button type="" className="btn bg_btn">Send</button>
                        </div>
                      </form>
                      <p className="text-white mb-3">Comments are pre-moderated to ensure they comply with <Link to="" className="text-white">our blog guidelines.</Link></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        <Footer />
      </div>
    </div>
  )
}
export default Blogdetals